export default {
  SET_CHANGED: (state, payload) => {
    state.changed = payload
  },
  ADD_LANGUAGE: (state, payload) => {
    state.languages.push(payload)
  },
  UPDATE_LANGUAGE: (state, { index, item }) => {
    state.languages.splice(index, 1, item)
  },
  REMOVE_LANGUAGE: (state, index) => {
    state.languages.splice(index, 1)
  },
  ADD_EDUCATION: (state, payload) => {
    state.education.push(payload)
  },
  UPDATE_EDUCATION: (state, { index, item }) => {
    state.education.splice(index, 1, item)
  },
  REMOVE_EDUCATION: (state, index) => {
    state.education.splice(index, 1)
  },
  ADD_EXPERIENCE: (state, payload) => {
    state.experiences.push(payload)
  },
  UPDATE_EXPERIENCE: (state, { index, item }) => {
    state.experiences.splice(index, 1, item)
  },
  REMOVE_EXPERIENCE: (state, index) => {
    state.experiences.splice(index, 1)
  },
  ADD_SKILL: (state, payload) => {
    state.skills.push(payload)
  },
  REMOVE_SKILL: (state, index) => {
    state.skills.splice(index, 1)
  },
  ADD_COURSE: (state, payload) => {
    state.courses.push(payload)
  },
  UPDATE_COURSE: (state, { index, item }) => {
    state.courses.splice(index, 1, item)
  },
  REMOVE_COURSE: (state, index) => {
    state.courses.splice(index, 1)
  },
  ADD_LICENCE: (state, payload) => {
    state.licences.push(payload)
  },
  REMOVE_LICENCE: (state, index) => {
    state.licences.splice(index, 1)
  },
  SET_HAS_CAR: (state, payload) => {
    state.hasCar = payload
  },
  SET_OTHER: (state, { key, value }) => {
    state.other[key] = value
  }
}
